import React, { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';

interface ToolLayoutProps {
  children: React.ReactNode;
  title: string;
  description: string;
  canonicalPath: string;
}

const ToolLayout: React.FC<ToolLayoutProps> = ({ children, title, description, canonicalPath }) => {
  useEffect(() => {
    document.title = title;

    // Update meta description
    let metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) {
      metaDesc.setAttribute('content', description);
    } else {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      metaDesc.setAttribute('content', description);
      document.head.appendChild(metaDesc);
    }

    // Update canonical
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `https://www.alltools.sbs${canonicalPath}`);

    // Update OG tags
    const setMeta = (property: string, content: string) => {
      let tag = document.querySelector(`meta[property="${property}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('property', property);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', content);
    };
    setMeta('og:title', title);
    setMeta('og:description', description);
    setMeta('og:url', `https://www.alltools.sbs${canonicalPath}`);
  }, [title, description, canonicalPath]);

  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <main className="container mx-auto px-4 py-8">
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-4 sm:p-6 lg:p-8 max-w-4xl mx-auto">
          {children}
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ToolLayout;
